import Checkbox from '@/components/Checkbox';
import IcoMoon, { IconNames } from '@/components/IcoMoon';
import { Stack } from '@/components/Layout';
import Text from '@/components/Text';
import { useUI } from '@/context/ui';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';

// CSS Classes
const root = "r6xqai9";
const labelClass = "l1bzidfn";
export interface Props {
  defaultChecked?: boolean;
  disabled?: boolean;
  hasActiveFilters: boolean;
  icon: IconNames;
  iconClass?: string;
  label: string;
  value: string;
  onChange?: (checked: boolean, value: string) => void;
  onFilterChange?: () => void;
}
const BadgeFilter = ({
  defaultChecked = false,
  disabled = false,
  hasActiveFilters,
  icon,
  iconClass,
  label,
  value,
  onChange,
  onFilterChange
}: Props): JSX.Element => {
  const {
    state: {
      schedulePage
    },
    dispatch
  } = useUI();
  const [checked, setChecked] = useState<boolean>(defaultChecked);
  const applyFilters = useCallback((checked: boolean) => {
    const facets: string[] = checked ? [...schedulePage.facets, value] : schedulePage.facets.filter((f: string) => f !== value);
    dispatch({
      type: 'SET_ACTIVE_SCHEDULE_FILTERS',
      payload: {
        ...schedulePage,
        day: dayjs(schedulePage.day).toISOString(),
        dayString: dayjs(schedulePage.day).format(),
        facets,
        index: 0,
        reset: true
      }
    });
  }, [schedulePage.day, schedulePage.facets]);
  useEffect(() => {
    if (onChange) {
      onChange(checked, value);
    } else {
      applyFilters(checked);
    }
    if (onFilterChange) onFilterChange();
  }, [checked]);

  // On Reset handler
  useEffect(() => {
    if (!hasActiveFilters) setChecked(false);
  }, [hasActiveFilters]);
  return <div className={root} onClick={() => setChecked(!checked)}>
      <Stack x justifyContent="flex-start" className="gap-xxs">
        <IcoMoon className={iconClass} icon={icon} size={24} />
        <Text className={labelClass} size="xs" weight="sm">
          {label}
        </Text>
      </Stack>
      <Checkbox key={`${label}-${checked}`} defaultChecked={checked} disabled={disabled} flush="right" label="" name={label} value={value} reverseEffect />
    </div>;
};
export default BadgeFilter;

require("./BadgeFilter.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./BadgeFilter.tsx");